import _mergeJSXProps from "@vue/babel-helper-vue-jsx-merge-props";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import { isXHRFileUpload } from '../utils';
import AjaxUploader from './ajaxUploader';
import Props from './props';
export default {
  name: 'Uploader',
  props: _objectSpread({}, Props, {
    supportServerRender: {
      type: Boolean,
      default: false
    }
  }),
  computed: {
    uploaderCmp: function uploaderCmp() {
      return isXHRFileUpload ? AjaxUploader : AjaxUploader;
    },
    bindProps: function bindProps() {
      var $props = this.$props;
      return _objectSpread({}, $props);
    },
    bindListeners: function bindListeners() {
      var $listeners = this.$listeners;
      return _objectSpread({}, $listeners);
    }
  },
  methods: {
    abort: function abort(file) {
      var uploaderRef = this.$refs.uploaderRef;

      if (uploaderRef) {
        uploaderRef.abort(file);
      }
    },
    upload: function upload(file, files) {
      var uploaderRef = this.$refs.uploaderRef;

      if (uploaderRef) {
        uploaderRef.upload(file, files);
      }
    }
  },
  render: function render() {
    var h = arguments[0];
    var slotDefault = this.$slots.default,
        bindProps = this.bindProps,
        bindListeners = this.bindListeners,
        UploaderCmp = this.uploaderCmp;
    return h(UploaderCmp, _mergeJSXProps([{}, {
      props: bindProps,
      on: bindListeners,
      ref: 'uploaderRef'
    }]), [slotDefault]);
  }
};